import { Link } from "@mui/material";

const OnlineStudyGroups = () => {
  return (
    <div className="container--blog_post_page_wrapper">
      <section className="container--blog_post">
        <div className="container--post_content">
          <p className="text--post_paragraph">
            So, you want to form an online study group? Research in the field of
            Educational Psychology shows that{" "}
            <Link
              href="https://source.wustl.edu/2006/07/discovering-why-study-groups-are-more-effective/"
              target="_blank"
              rel="nofollow sponsored"
              aria-label="Read more about the effectiveness of study groups at Washington University in St. Louis"
            >
              study groups improve learning
            </Link>
            . They allow you to explore new ideas, and can provide a sounding
            board for your own. They help teammates to share the workload, and
            to develop team skills that will continue to serve them long after
            graduation. And now, with more and more students switching from
            in-person to online classes because of the recent pandemic, the need
            for online study groups has never been greater. So, how exactly do
            you go about finding the right study mates online?
          </p>
          <h2 className="header header--page_title_h2_left">Find Teammates</h2>
          <p className="text--post_paragraph">
            Your best bet for finding the right study mates online is joining
            platforms that specifically cater to creating teams, like
            TeammateMe. TeammateMe is the optimal platform when it comes to
            forming, joining, and finding teams. First, sign up for free. Then
            create an online profile that tells people who you are and what your
            skills are. You can then decide to form a team and describe what
            your mission is, what skills you need to accomplish your goal, or
            look and apply for a team that suits you. The best parts about
            TeammateMe is that it allows you to rate and review your teammates
            anonymously. The peer rating scores allow users to make
            better-informed decisions when selecting the potential study mates.
            Platforms like TeammateMe have made it easier to find and create
            teams online. However, finding the right teammates is only the first
            step for building a successful study group online.
          </p>
          <h2 className="header header--page_title_h2_left">
            Create an Agenda
          </h2>
          <p className="text--post_paragraph">
            The success of each of your study meetings depends on your
            organization. You should discuss the exact time of the meeting, the
            material you are planning to discuss, what assignments and reading
            should be completed by the time of the meeting, and who is in charge
            of which sections. This prevents people from showing up to the team
            meeting without knowing what exactly is going, causing a lot of
            studying and discussion time to go to waste. You can even designate
            one of your teammates to create the agenda and share it with all
            teammates before the team meeting.
          </p>
          <h2 className="header header--page_title_h2_left">Get a Moderator</h2>
          <p className="text--post_paragraph">
            Choosing a team member to act as a moderator during a team meeting
            is very important to ensure that everyone’s opinions and suggestions
            are heard. Let’s face it when it comes to discussions, especially
            one the team is truly passionate about. People will likely talk over
            each other, and some individual’s opinions will not be heard. A
            moderator ensures that there is order and organization during the
            meeting so that it can be as productive as possible. Furthermore,
            the moderator does not need to be the same person every discussion.
            You can choose to switch them up during each discussion to ensure
            everyone participates in keeping the team organized. Moreover, you
            can choose to give the moderator a moderator badge to ensure that
            everyone is aware of them and follows their instructions.
          </p>
          <h2 className="header header--page_title_h2_left">
            Learn to Strike a Balance
          </h2>
          <p className="text--post_paragraph">
            When more than one person comes together to work on a team project,
            there is no way connections and relationships will not be formed.
            These relationships are vital as they help to create team synergy.
            Nevertheless, these relationships can sometimes lead to some study
            meetings turning into social time. Some socializing is both natural
            and healthy for strong teams, despite the potential for lower team
            productivity if it gets out of hand. Thus the trick is finding a
            balance. Teammates should schedule a time to interact and check in
            with each other during their meeting and then go back to your study
            time. With this, you get the best of both worlds. Students can get
            work done and interact with their new friends.
          </p>
          Spring into action&mdash; join TeammateMe today to find the study
          mates who are right for you!<p></p>
        </div>
        <hr className="hr--form_break" />
      </section>
    </div>
  );
};

export default OnlineStudyGroups;
